export default __webpack_public_path__ + "static/media/cuate.a4f52e72.png";